import { MdxDiv } from '@features/mdx/MdxDiv';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: '28283c10-85a5-43df-b5a8-8cb4145d5a79',
	[LanguageEnum.SK]: '28283c10-85a5-43df-b5a8-8cb4145d5a79',
	default: '28283c10-85a5-43df-b5a8-8cb4145d5a79'
}


export const InfoboxProbe = () => {

	return (
		<MdxDiv className='info-box' articleIds={articleIds}>
		</MdxDiv>
	);
};